/**
 * canAccess — vérifie si l'utilisateur possède un privilege_key donné.
 *
 * - admin          → accès total garanti (bypass)
 * - autres         → doit avoir la clé exacte dans user.privileges
 *
 * Exemples :
 *   canAccess(user, 'ouvriers')         → peut voir la page
 *   canAccess(user, 'ouvriers:write')   → peut créer / modifier
 *   canAccess(user, 'ouvriers:delete')  → peut supprimer
 *   canAccess(user, 'ouvriers:all')     → accès à tous les chantiers
 */
export const canAccess = (user, privilegeKey) => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  return Array.isArray(user.privileges) && user.privileges.includes(privilegeKey);
};
